import { apiSlice } from "../../api/ApiService";

const getPatientListApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientList: builder.query({
      query: ({ accessToken }: { accessToken: string | null }) => ({
        url: `/api/v1/Administration/manage-patient-overview`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),
      providesTags: (result, error) => [{ type: "PatientList" }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPatientListQuery } = getPatientListApi;
export default getPatientListApi;
